// AWS Region
export const AWS_REGION = process.env.REACT_APP_AWS_REGION as string;

// Cognito Configuration
type CognitoConfig = {
  region: string;
  maxAttempts: number
  userPoolId: string;
  identityPoolId: string;
  roleName: string;
  flow: 'implicit';
  baseUrl: string;
  clientId: string;
  scopes: string[];
  signInRedirectUrl: string;
  signOutRedirectUrl: string;
}

export const cognito: CognitoConfig = {
  region: AWS_REGION,
  maxAttempts: 5,
  userPoolId: process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID as string,
  identityPoolId: process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID as string,
  roleName: process.env.REACT_APP_AWS_COGNITO_ROLE_NAME as string,
  flow: 'implicit',
  baseUrl: process.env.REACT_APP_AWS_COGNITO_DOMAIN as string,
  clientId: process.env.REACT_APP_AWS_COGNITO_CLIENT_ID as string,
  scopes: ['openid', 'profile', 'email'],
  signInRedirectUrl: `${window.location.origin}/sso`,
  signOutRedirectUrl: `${window.location.origin}/logout`,
}

// DynamoDB Configuration
type DynamoDbConfig = {
  region: string;
  maxAttempts: number;
  userTableName: string;
}

export const dynamodb: DynamoDbConfig = {
  region: AWS_REGION,
  maxAttempts: 5,
  userTableName: process.env.REACT_APP_AWS_DYNAMODB_USER_TABLE_NAME as string,
}